class SubscriptionPopup extends HTMLElement {
  constructor() {
    super();
    
    if (window.location.pathname === '/challenge') {
      return;
    }
    this.cookieName = 'fusion:subscription-popup';
    this.popup = this;
    this.classes = {
      bodyClass: 'subscription-modal-open',
      overlayCLass:"overflow-hidden",
      activeClass: 'is-visible',
      closingClass: 'closing',
    };
    // Open popup if errors or success message exist
    if (this.querySelector('.form-success-message')) {
      this.open();
      // Signed up successfully: don't show the popup again for a long time
      this.setCookie(this.cookieName, 365);
      // Auto-dismiss the success message after a few seconds (visual only,
      // does not touch the cookie set above)
      setTimeout(() => {
        this.hide();
      }, 2000);
    }
    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (!this.getCookie(this.cookieName)) {
      this.init();
    }
  }
  init() {
    if(!this.popup) {
      return;
    }

    setTimeout(function() {
      this.open();
      
    }.bind(this), parseInt(2) * 1000);
  }
  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }
  open() {
    document.body.classList.remove(this.classes.bodyClass);
    if (this.dataset.subscriptionpopup == 'true') {
      document.body.classList.add(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);
       document.body.classList.add(this.classes.overlayCLass);
    }
  }
  close() {
    this.hide();
    this.setSessionCookie(this.cookieName);
  }
  hide() {
    this.popup.classList.add(this.classes.closingClass);
    document.body.classList.remove(this.classes.overlayCLass);
    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
    }, 500);
  }
  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }
  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }
  setSessionCookie(name) {
    // No max-age: expires when the browser session ends, so it reappears on the next visit
    document.cookie = `${name}=true; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('subscription-popup', SubscriptionPopup);
